import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Message } from '../../http/message';

@Component({
    selector: 'app-custom-snackbar',
    templateUrl: './custom-snackbar.component.html',
    styleUrls: ['./custom-snackbar.component.scss'],
})

export class CustomSnackBarComponent {

    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: Message, public snackBarRef: MatSnackBarRef<CustomSnackBarComponent>) {
            this.snackBarRef._dismissAfter(data.Duration);
    }

    public dismiss() {
        this.snackBarRef.dismiss();
    }
}
